"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getHttpServiceInstance = exports.HttpService = void 0;
var _axios = _interopRequireDefault(require("axios"));
var _constants = require("../utils/constants");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
class HttpService {
  constructor(props) {
    var _this = this;
    this.axiosInstance = void 0;
    this.requestQueue = [];
    this.isProcessing = false;
    this.controller = new AbortController();
    this.currentRequest = null;
    this.setup = _ref => {
      let {
        api,
        tenant,
        appId
      } = _ref;
      const {
        baseURL
      } = api;
      this.axiosInstance = _axios.default.create({
        baseURL,
        headers: {
          'X-Tenant': tenant.toLowerCase(),
          'vf-project': 'guidedSelling',
          'x-app-id': appId !== null && appId !== void 0 ? appId : 'x-app-id not set'
        }
      });
    };
    this.formatRequestLog = function () {
      var _request$method;
      let request = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      const requestLog = {};
      requestLog.method = (_request$method = request.method) === null || _request$method === void 0 ? void 0 : _request$method.toUpperCase();
      requestLog.host = request.baseURL;
      requestLog.path = request.url;
      requestLog.headers = request.headers;
      if (request.data) {
        requestLog.body = request.data;
      }
      return requestLog;
    };
    this.formatResponseLog = function () {
      let response = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      const responseLog = {};
      responseLog.headers = response.headers;
      responseLog.status = response.status;
      if (response.data) {
        responseLog.body = response.data;
      }
      return responseLog;
    };
    this.processQueue = async () => {
      if (this.isProcessing || this.requestQueue.length === 0) return;
      this.isProcessing = true;
      const {
        method,
        url,
        params,
        resolve,
        reject
      } = this.requestQueue.shift();
      try {
        const result = await this.httpRequest(method, url, params);
        resolve(result);
      } catch (error) {
        if (error.message === 'canceled') {
          reject({
            ...error,
            message: _constants.DUPLICATE_REQUEST_CANCELLATION
          });
        } else {
          reject(error);
        }
      } finally {
        this.isProcessing = false;
        this.processQueue();
      }
    };
    this.addToQueue = function (method, url) {
      let params = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
      return new Promise((resolve, reject) => {
        var _this$currentRequest, _this$currentRequest$, _this$currentRequest$2;
        // compare the url with other urls in the queue and only take latest request if they are to the same endpoint
        _this.requestQueue = _this.requestQueue.filter(request => request.url.split('?')[0] !== url.split('?')[0]);
        //additionally if there is a request to the same endpoint, cancel the previous request
        if (((_this$currentRequest = _this.currentRequest) === null || _this$currentRequest === void 0 ? void 0 : (_this$currentRequest$ = _this$currentRequest.url) === null || _this$currentRequest$ === void 0 ? void 0 : (_this$currentRequest$2 = _this$currentRequest$.split('?')) === null || _this$currentRequest$2 === void 0 ? void 0 : _this$currentRequest$2[0]) === url.split('?')[0]) {
          _this.controller.abort("Request cancelled because it's a duplicate request");
          _this.controller = new AbortController();
          _this.currentRequest = null;
        }
        _this.requestQueue.push({
          method,
          url,
          params,
          resolve,
          reject
        });
        _this.processQueue();
      });
    };
    this.httpRequest = async function (method, url) {
      let params = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
      const requestObj = {
        method,
        url,
        signal: _this.controller.signal
      };
      if (params.data) {
        requestObj.data = params.data;
      }
      let rawResponse = null;
      const requestStart = Date.now();
      try {
        _this.currentRequest = requestObj;
        rawResponse = await _this.axiosInstance.request(requestObj);
        _this.currentRequest = null;
        return rawResponse.data;
      } catch (e) {
        rawResponse = e.response;
        console.info(e);
        throw e;
      } finally {
        var _rawResponse;
        const requestEnd = Date.now();
        console.info([`${requestEnd - requestStart}ms`, _this.axiosInstance.getUri(requestObj), _this.formatRequestLog((_rawResponse = rawResponse) === null || _rawResponse === void 0 ? void 0 : _rawResponse.config), _this.formatResponseLog(rawResponse)]);
      }
    };
    this.get = async url => {
      return this.addToQueue('get', url);
    };
    this.post = async (url, data) => {
      return this.addToQueue('post', url, {
        data
      });
    };
    this.patch = async (url, data) => {
      return this.addToQueue('patch', url, {
        data
      });
    };
    if (HttpService.instance) {
      return HttpService.instance;
    }
    this.setup(props);
    HttpService.instance = this;
  }
  static getInstance(props) {
    if (!HttpService.instance) {
      HttpService.instance = new HttpService(props);
    }
    return HttpService.instance;
  }
}
exports.HttpService = HttpService;
HttpService.instance = null;
const getHttpServiceInstance = props => HttpService.getInstance(props);
exports.getHttpServiceInstance = getHttpServiceInstance;